import { createFileRoute } from "@tanstack/react-router";
import { SettingsShell } from "@/features/settings";

export const Route = createFileRoute("/settings")({
  component: SettingsShell,
});
